import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// DTA-949: the coupon books the signed-in family user holds in a district,
// and that district's community sponsors.
export interface HeldCouponBook {
  token: string
  name: string
  beneficiary: string
  expires: string
  status: 'active' | 'suspended' | 'cancelled'
  offers: number
  available: number
}

export interface CommunitySponsor {
  sponsorId: number
  name: string
  category: string | null
  description: string | null
  level: 'gold' | 'silver' | 'listed'
  logo: string | null
  banner: string | null
  phone: string | null
  website: string | null
  beneficiary: string
  locations: string[]
  offers: string[]
  leadOffer: string | null
  bookId: number
  bookName: string
  teamId: number | null
}

// Where a sponsor is being shown (DTA-949 Sponsor Display).
export type SponsorPlacement = 'dashboard' | 'activities' | 'team' | 'portal_page'

// GET /ajax/coupon-books/{districtId}/mine
export const myCouponBooks = async (districtId: number): Promise<HeldCouponBook[]> => {
  const response = await new Request().get(`/ajax/coupon-books/${districtId}/mine`)
  return Util.Obj.keysToCamel(response.data.books) as HeldCouponBook[]
}

// GET /ajax/coupon-books/{districtId}/sponsors?placement=&team_ids=
export const communitySponsors = async (
  districtId: number,
  placement: SponsorPlacement = 'portal_page',
  teamIds: number[] = []
): Promise<CommunitySponsor[]> => {
  const query = new URLSearchParams({ placement })
  if (teamIds.length) query.set('team_ids', teamIds.join(','))
  const response = await new Request().get(`/ajax/coupon-books/${districtId}/sponsors?${query}`)
  return Util.Obj.keysToCamel(response.data.sponsors) as CommunitySponsor[]
}
